<template>
  <div class="member-info">
    <div class="operation-wrap">
      <div class="operate-left-wrap">
        <el-alert
          style="width:100%;"
          :closable="false"
          :title="`整体作业状态：${homeworkStatusName}`"
          type="warning">
        </el-alert>
      </div>
      <!-- <div class="search-wrap">
        <span>筛选：</span>
        <el-select
            v-model="workhomeStatus"
            placeholder="请选择作业状态"
            class="subject-type"
            :disabled="disabled"
            :title="disabledTip">
            <el-option
              v-for="item in subjectTypes"
              :key="item.subjectXgkType"
              :label="item.typeName"
              :value="item.subjectXgkType">
            </el-option>
          </el-select>
      </div> -->
    </div>
    <el-table :data="homeworkList" stripe :highlight-current-row="true" height="calc(100vh - 97px - 20px - 41px - 44px - 32px)">
      <el-table-column prop="fileName" label="文件名" align="center"></el-table-column>
      <el-table-column prop="studentNumber" label="学生学号" align="center"></el-table-column>
      <!-- <el-table-column prop="studentName" label="学生姓名" align="center"></el-table-column> -->
      <el-table-column align="center" label="批阅状态/错误原因">
        <template slot-scope="scope">
          <span v-if="scope.row.failReasonMsg">{{ scope.row.failReasonMsg }}</span>
          <span v-else>{{ scope.row.studentTaskStatusName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" class="operate" @click="uploadHomeWork(scope.$index, scope.row)">重新上传</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
      v-if="totalPages!==0"
      class="pagination"
      :current-page.sync="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="totalPages"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination> -->
    <!-- 修改弹窗 -->
    <upload-homework-dialog :taskId="taskId" :dialogVisible="uploadDialogVisible" @dialog-close="handleUploadClose" />
  </div>
</template>

<script>
import { getClassWorkStatus } from '@/model/homework-model'
import common from '@/util/common'
import UploadHomeworkDialog from './UploadHomeworkDialog'

export default {
  name: 'MemberInfo',
  props: {
    orgId: {
      type: String,
      required: true
    }
  },
  components: {
    UploadHomeworkDialog
  },
  data () {
    return {
      homeworkList: [],
      homeworkStatus: '',
      MemberEditDgVisible: false,
      editUserId: '',
      searchMsg: '',
      tmpMemberList: [],
      subjects: [],
      selectedSubject: [],
      filterFlag: true,
      totalPages: 1,
      currentPage: 1,
      pageSize: 2000,
      firstInfoManagerId: '',
      uploadDialogVisible: false
    }
  },
  methods: {
    handleUploadClose (done) {
      this.uploadDialogVisible = false
    },
    handleImportTeacher () {
      this.importTeacherVisible = true
    },
    // handleSearchUser () {
    //   this.filterFlag = false
    //   this.selectedSubject = []
    //   this.currentPage = 1
    //   this.queryUserList(this.searchMsg, null)
    // },

    // 处理展示错误信息弹窗事件
    handleShowErrorDg (errorMsg, errorLink, taskId, taskType) {
      if (errorLink && errorLink !== '') {
        this.alertImportError(['导入遇到问题，未能导入成功。'], errorLink, taskId, taskType)
      } else {
        this.alertImportError([errorMsg], null, taskId, taskType)
      }
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1 // 重新回到第一页
      let param = null
      if (this.selectedSubject[1]) {
        param = {
          studyStep: this.selectedSubject[0],
          subjectName: this.selectedSubject[1]
        }
      }
      this.queryUserList(this.searchMsg, param)
    },

    handleCurrentChange (val) {
      this.currentPage = val
      let param = null
      if (this.selectedSubject[1]) {
        param = {
          studyStep: this.selectedSubject[0],
          subjectName: this.selectedSubject[1]
        }
      }
      this.queryUserList(this.searchMsg, param)
    },

    closeImportAccountDg () {
      this.batchImportTeacherVisible = false
    },

    uploadHomeWork () {
      this.uploadDialogVisible = true
    },

    editSuccessfully () {
      this.currentPage = 1
      this.queryUserList()
    },

    /**
     * 查询作业状态列表
     * @param [String] consition 查询条件 为空代表搜索全部
     */
    queryClassWorkStatus (condition = '', filterSubject = null) {
      let param = {
        data: {
          taskId: this.taskId
        },
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      getClassWorkStatus(param).then(res => {
        if (res.result.toString() === 'true') {
          this.homeworkStatus = res.data.taskStatus
          for (let errorInfo of res.data.errorFileList) {
            let tempArray = errorInfo.fileUrl.split('/')
            let fileName = tempArray[tempArray.length - 1]
            this.homeworkList.push({
              fileName,
              ...errorInfo
            })
          }
        }
      }).catch(e => {
        console.log(e)
        this.alertError('网络出错，请稍后重试')
      })
    }
  },
  mounted () {
    this.queryClassWorkStatus()
  },
  computed: {
    userInfo () {
      return common.getUserInfo()
    },
    taskId () {
      return this.$route.params.taskId
    },
    homeworkStatusName () {
      switch (this.homeworkStatus.toString()) {
        case '1':
          return '未开始批阅'
        case '2':
          return '批阅中'
        case '3':
          return '批阅完成'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss">
.member-info{
  .operate{
    width: 100px;
  }

  .operation-wrap{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .operate-left-wrap{
    margin-bottom: 12px;
    width: 100%;
  }

  .input-with-search{
    width: 180px;
    border-radius: 8px;
  }

  .search-wrap{
    margin-bottom: 12px;
    color: #737171;
  }

  .search{
    font-size: 16px;
    cursor: pointer;
    &:hover{
      color: $color-label;
    }
  }

  .seperate{
    display: inline-block;
    margin: 0 12px;
    font-size: 18px;
    color: #b7b2b2;
  }

  .import-error-tip{
    display: inline-block;
    padding: 5px 4px;
    border: 1px solid #d93701;
    background: #ffefbf;
    color: #d93701;
  }

  .lookup-reason{
    text-decoration: underline;
    cursor: pointer;
    &:hover{
      color: #af3208;
    }
  }

  .pagination{
    margin: 6px 0;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home-work/work/UploadView.vue